import React, { PureComponent } from 'react';

export default class AdminUpgradeIcon extends PureComponent {

    render() {
        const {firstColor, secondColor, width, height} = this.props
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 20">
                <defs>
                    <linearGradient x1="-32.549%" y1="1.185%" x2="72.093%" y2="66.589%" id="aaa">
                        <stop stopColor={firstColor} offset="0%"/>
                        <stop stopColor={secondColor} offset="100%"/>
                    </linearGradient>
                </defs>
                <path d="M21.828 0H2.4C1.08 0 .012 1.125.012 2.5v5C1.332 7.5 2.4 8.625 2.4 10S1.332 12.5 0 12.5v5C0 18.875 1.08 20 2.4 20h19.2c1.32 0 2.4-1.125 2.4-2.5v-15c0-1.375-.972-2.5-2.172-2.5zm-2.952 11.625-10.632 2.95-1.992-3.6 1.116-.313L8.88 11.9l2.868-.8-2.88-5.2 1.68-.475L15.36 10.1l2.928-.813c.612-.175 1.248.213 1.416.85.156.638-.204 1.3-.828 1.488z" fill="url(#aaa)" fill-rule="nonzero"/>
            </svg>)
    }
}